import axios from 'axios';
import './CourseTrainingPage.css';
import React, { useEffect, useState } from 'react'
import { BaseUrl } from '../../Constants/Constants';
import { Card, Col, Pagination, Row } from 'antd';
import Meta from 'antd/es/card/Meta';
import { useNavigate, useParams } from 'react-router-dom';

const CourseTrainingPage = () => {

    const [Loading, setLoading] = useState(false);
    const [course, setcourse] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(12);

    const navigate = useNavigate();
    const { type } = useParams();
    console.log(type, 'locationType')

    const paginatedCourses = course.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    useEffect(() => {
        CourseTable();
    }, [type]);

    const handlePaginationChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleCard = (e) => {
        navigate(`/emailconfigurations/${type}/${e}`);
        console.log(e.id, "id")
    }

    const CourseTable = () => {
        setLoading(true);
        if (type === 'courses') {
            axios
                .get(`${BaseUrl}courses/findAll`, {withCredentials:true})
                .then((res) => {
                    console.log(res.data.data, "courseFindall");

                    // Sort the data in descending order based on date and time
                    const sortedData = res.data.data.sort((a, b) => {
                        // Ensure 'modified_at' is a valid date string
                        return new Date(b.created_at) - new Date(a.created_at);
                    });

                    setcourse(sortedData);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        } else {
            axios
                .get(`${BaseUrl}trainings/getAllTraining`, {withCredentials:true})
                .then((res) => {
                    setcourse(res.data.data);
                    setLoading(false)
                })
                .catch((err) => {
                    console.log(err)
                    setLoading(false)
                })
        }
    };

    return (
        <div className='emailConfigMainClass'>
            <h2>Email Configurations</h2>
            <div className='courseTrainingDiv'>
                <h3 className={type === 'courses' ? 'courseActiveClass' : ''} style={{ borderRadius: '6px 0px 0px 6px' }} onClick={() => navigate('/emailconfigurations/courses')}>Courses</h3>
                <h3 className={type === 'trainings' ? 'trainingActiveClass' : ''} style={{ borderRadius: '0px 6px 6px 0px' }} onClick={() => navigate('/emailconfigurations/trainings')}>Trainings</h3>
            </div>
            {
                Loading ?
                    <div className='Loader' >

                        <img src='/Loader/Ellipsis-2.9s-200px.svg'>
                        </img>
                    </div>
                    :
                    <>
                        <Row className='manageChatbotRow'>
                            {
                                type === 'courses' ?
                                    <>
                                        {course.length > 0 ? (
                                            <>
                                                {paginatedCourses.map((item) => {
                                                    console.log(item.courseImg, "item")
                                                    return (
                                                        <div className="Course-card">
                                                            <Col span={4} className="manageBotCardCol">
                                                                <Card
                                                                    onClick={() => handleCard(item.course_id)}
                                                                    hoverable
                                                                    className="cards"
                                                                    style={{
                                                                        width: 200,
                                                                        height: '178px',
                                                                        padding: 2,
                                                                    }}
                                                                    cover={
                                                                        <img
                                                                            src={item.course_img !== "" && item.course_img !== null ? item.course_img : "/icons/CourseIcons.png"}
                                                                            alt="Bot Image"
                                                                            // src="/icons/CourseIcons.png"
                                                                            height={130}

                                                                        />
                                                                    }
                                                                >


                                                                    <Meta title={item.course_title || `Course ${item.num}`} />
                                                                </Card>
                                                            </Col>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <div className="noCourseDIv">
                                                <h3 className="noCourseHeading">No Courses</h3>
                                            </div>
                                        )}
                                    </>
                                    :
                                    <>
                                        {course.length > 0 ? (
                                            <>
                                                {paginatedCourses.map((item, key) => {
                                                    // let training_end_date_dbVal = item?.training_end_date.split('T');
                                                    // let training_end_date = training_end_date_dbVal[0];

                                                    // // Split the date into parts
                                                    // let dateParts = training_end_date.split('-');

                                                    // // Rearrange the parts to dd/mm/yyyy
                                                    // let formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
                                                    // console.log(training_end_date, "item_training_end_date")
                                                    return (
                                                        <div className="Course-card" key={key}>
                                                            <Col span={6} className="manageBotCardCol">
                                                                <Card
                                                                    onClick={() => handleCard(item.training_id)}
                                                                    hoverable
                                                                    className="cards"
                                                                    style={{
                                                                        width: 200,
                                                                        padding: 2,
                                                                    }}
                                                                    cover={
                                                                        <img
                                                                            src={item.training_img != null && item.training_img != "" ? item.training_img : "/icons/CourseIcons.png"}
                                                                            alt="Bot Image"
                                                                            // src="icons/CourseIcons.png"
                                                                            height={130}
                                                                        />
                                                                    }
                                                                >

                                                                    <Meta title={item.training_title || `Training ${item.num}`} />
                                                                    {/* <p className="endDateCardClass"><strong>End date</strong> - {formattedDate}</p> */}
                                                                </Card>
                                                            </Col>
                                                        </div>
                                                    );
                                                })}

                                            </>
                                        ) : (
                                            <div className="noCourseDIv">
                                                <h3 className="noCourseHeading">No Trainings</h3>
                                            </div>
                                        )}
                                    </>
                            }


                        </Row>
                        <Pagination
                            onChange={handlePaginationChange}
                            current={currentPage}
                            pageSize={pageSize}
                            showSizeChanger={false}
                            total={course.length}
                            style={{ position: 'absolute', bottom: '0px', left: '45%' }}
                        />
                    </>
            }
        </div>
    )
}

export default CourseTrainingPage